import styled from "styled-components";

export const DialogBoxContainer = styled.div`
  display: grid;
  grid-template-columns: 14px auto;
  margin-right: 12px;
  margin-bottom: 12px;
`;

export const DialogBoxChildren = styled.div`
  display: grid;
  row-gap: 7px;
`;
